
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import RegisterText from './agreement/registerText.vue';
import smsVerifyUser from './agreement/smsVerifyUser.vue';
import userInfo from './userInfo.vue';
export default {
directives: {
TransferDom,
},
components: {
Group,
XInput,
XButton,
XDialog,
RegisterText,
smsVerifyUser,
userInfo,
},
name: 'register',
data () {
return {
movePhone: '',
phoneCheck: false,
showCode: false,
userInfo: {
userName: '',
ide: '',
movePhone: ''
},
showInfo: false,//是否已发短信
code: '',
showReturn: false,
buttonText: '查询',
hideButton: false,//隐藏按钮
}
},
created(){
},
computed: {
isFill: function () {
return  this.phoneCheck;
}
},

methods: {

beforeRouteLeave(to, from, next){
to.meta.keepAlive = true
next()
},
getImage(id) {
return require(`@/assets/images/${id}.png`);
}
,
doShowToast() {
this.showDialog = true;
this.agreeBtnFlag = false
},
submitInformation() {
if (this.isFill == true) {
this.showCode = true;
this.code = '';
}
},

movePhoneCheck() {

const movePhone = this.movePhone;
if (!movePhone || movePhone === '') {

this.phoneCheck = false;
return false
}
const phoneReg = /^\d{11}$/
if (!phoneReg.test(movePhone)) {

this.phoneCheck = false;
return false
}
this.phoneCheck = true;
return true;
},
checkPhone () {
if (!this.phoneCheck) {
this.$vux.toast.text('请输入正确的11位手机号');
}
},

sendSMS () {
const thiss = this;
const url = '/wechat/queryVerify.do?movePhone=' + this.movePhone;
this.$axios({
method: 'get',
url: url
}).then((response) => {

if (response.data.code === 200) {
thiss.$vux.toast.show("发送成功");
thiss.showInfo = true;
} else {
thiss.$vux.toast.show("发送失败")
}
}).catch((error) => {
thiss.$vux.toast.show("发送失败");
});
},

confirmSMS () {
if (this.code == '' || this.code == null) {
this.$vux.toast.text("请输入验证码");
return;
}
if (!this.showInfo) {
this.$vux.toast.text("请发送验证码");
return;
}

const thiss = this;
const url = '/wechat/queryByVerify.do';
this.$axios({
method: 'post',
url: url,
data: {
movePhone: thiss.movePhone,
verifyCode: thiss.code,
}
}).then((response) => {

if (response.data.code === 200) {
thiss.userInfo = response.data.result;
thiss.$vux.toast.show("查询成功");
thiss.hideButton = true;
thiss.showCode = false;
} else {
thiss.$vux.toast.show("验证失败");
}
}).catch((error) => {
thiss.phoneCheck = false;
});
}

}
}



// WEBPACK FOOTER //
// ./src/pages/queryUser.vue